module.exports = __webpack_public_path__ + "static/angle-up-disabled.4d3769902e4eb2204bbdf6ea2c6e9233.svg";